import { Avatar, Tooltip } from 'antd';
import { useStore } from '../store/store';
import { scrollToItem } from '../components/Middle/InfinitePage';
import { useOverlay, leftShownStatus } from '../contexts/OverlayContext';

const selector = (state) => ({
  presence: state.presence,
  currentUserId: state.user?.id,
  boxLocks: state.boxLocks,
  boxes: state.boxes,
  closePreview: state.closePreview,
  isPreviewOpen: state.previewRenderState && state.pagesPreview.length > 0,
});

const initials = (name) =>
  (name ?? '')
    .split(' ')
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

// Avatars des co-éditeurs connectés sur le même document (présence collab).
// Soi-même est exclu ; rien n'est rendu quand on est seul.
export const PresenceBar = () => {
  const { presence, currentUserId, boxLocks, boxes, closePreview, isPreviewOpen } =
    useStore(selector);
  const { overlayProps, updateLeftShownStatus } = useOverlay();

  // Scrolle jusqu'à la box éditée par un co-éditeur. boxLocks peut contenir des
  // clés de box ou de variable : on retient la première qui est une box. Si on
  // est dans l'aperçu ou le formulaire (overlays plein écran), on en sort
  // d'abord — l'InfinitePage reste monté dessous, donc on scrolle au frame
  // suivant une fois les overlays fermés.
  const goToUserBox = (userId) => {
    const box = Object.keys(boxLocks)
      .filter((k) => boxLocks[k]?.id === userId)
      .map((k) => boxes.find((b) => b.id === k))
      .find(Boolean);
    if (!box) return;
    if (isPreviewOpen) closePreview();
    if (overlayProps.left.shownStatus === leftShownStatus.VARIABLES) {
      updateLeftShownStatus(leftShownStatus.SUMMARY);
    }
    requestAnimationFrame(() => scrollToItem(box));
  };

  const others = presence.filter((u) => u.id !== currentUserId);
  if (others.length === 0) return null;

  return (
    <Avatar.Group max={{ count: 4 }} style={{ marginRight: 8 }}>
      {others.map((u) => {
        const isEditing = Object.values(boxLocks).some((l) => l?.id === u.id);
        return (
          <Tooltip
            key={u.id}
            title={isEditing ? `${u.name} — aller à son bloc` : u.name}
          >
            <Avatar
              shape='square'
              src={u.avatar_url || undefined}
              onClick={isEditing ? () => goToUserBox(u.id) : undefined}
              style={{
                height: '32px',
                width: '32px',
                // Carré aux coins de 5 px, comme les boutons de la barre du haut (navbarButtonStyle).
                borderRadius: 5,
                backgroundColor: u.avatar_url ? undefined : u.color,
                border: u.avatar_url ? `2px solid ${u.color}` : '2px solid #fff',
                cursor: isEditing ? 'pointer' : 'default',
              }}
              size='default'
            >
              {u.avatar_url ? null : initials(u.name)}
            </Avatar>
          </Tooltip>
        );
      })}
    </Avatar.Group>
  );
};

export default PresenceBar;
